import React from "react"
import styled from '@emotion/styled'
import Img from 'gatsby-image'

const HeroHeaderContainer = styled.header`
  display: flex;
  xxx_margin: 5rem 0;
  padding: 4rem 0;
`

const HeroBlurb = styled.div`
  flex: 1;
  padding-right: 2rem;

  > h1 {
    font-size: 3.5rem;
    font-weight: 600;
    color: #184233;
    margin: 2rem 0 3rem 0;
  }
`

const HeroText = styled.div`
  color: #373f3d;
  line-height: 34px;
`

const HeroHeader = ({title, html, image}) => (
  <HeroHeaderContainer>
    <HeroBlurb>
      <h1>{title}</h1>
      <HeroText dangerouslySetInnerHTML={{__html: html}} />
    </HeroBlurb>
    {
      image && 
      <Img
        style={{ flex: 1 }}
        fluid={image.fluid} />
    }
  </HeroHeaderContainer>
)

export default HeroHeader
